module.exports = __webpack_public_path__ + "media/images/logo-GCRF-ca861d47a490645d3c5501673ff28781.png";